import {Component, OnInit} from '@angular/core';
import {DialerCall, DialerCallState, DialerService} from '../dialer.service';
import {isNullOrUndefined} from 'util';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-call-status-box',
  templateUrl: './call-status-box.component.html',
  styleUrls: ['./call-status-box.component.css']
})
export class CallStatusBoxComponent implements OnInit {

  readonly callTimeSK = 'actualCallTime';

  statusText = '-';
  statusClass = ['btn-success'];
  statusSymbolClass = ['fa', 'fa-server'];
  callTime = 0;

  callTimeSubscription: Subscription = null;

  constructor(private ds: DialerService) {
  }

  ngOnInit() {
    this.ds.actualCallSubject.subscribe((dc: DialerCall) => {
      if (isNullOrUndefined(dc)) {
        this.statusText = '-';
        this.statusClass = ['btn-success'];
        this.statusSymbolClass = ['fa', 'fa-refresh'];
      } else {
        this.statusText = dc.getStatusText();
        this.statusClass = ['btn-' + dc.getStatusClass()];
        this.statusSymbolClass = dc.getStatusSymbolClass();
        this.processCallTime(dc);
      }
    });
  }

  processCallTime(dc: DialerCall) {
    if (dc.state === DialerCallState.CREATED) {
      this.callTime = 0;
      console.log(`Saved ${dc.id} start time`);
      localStorage.setItem(this.callTimeSK, JSON.stringify({'id': dc.id, 'startTime': (new Date()).getTime()}));
      if (!isNullOrUndefined(this.callTimeSubscription)) {
        this.callTimeSubscription.unsubscribe();
      }
      this.callTimeSubscription = Observable.interval(1000)
        .map((i: number) => {
          console.log(`updating time ${i}s`);
          return this.getActualCallTime(this.ds.actualCallSubject.getValue());
        })
        .subscribe((actualCallTime: number) => {
          console.log(`setting calltime to ${actualCallTime}s`);
          if (dc.isFinished() && !isNullOrUndefined(this.callTimeSubscription)) {
            this.callTimeSubscription.unsubscribe();
          }
          this.callTime = actualCallTime;
        });
    }
    if (dc.isFinished() && !isNullOrUndefined(this.callTimeSubscription)) {
      this.callTimeSubscription.unsubscribe();
      this.callTime = this.getActualCallTime(dc);
    }
  }

  getActualCallTime(dc: DialerCall): number {
    const callTimeStr = localStorage.getItem(this.callTimeSK);
    if (!isNullOrUndefined(callTimeStr)) {
      const callTimeObj = JSON.parse(callTimeStr);
      if (isNullOrUndefined(callTimeObj.id) || isNullOrUndefined(callTimeObj.startTime) || callTimeObj.id !== dc.id) {
        return 0;
      } else {
        if (dc.isFinished()) {
          console.log(`returning duration: ${dc.duration}`);
          return dc.duration;
        }
        return (new Date()).getTime() - callTimeObj.startTime;
      }
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/call-status-box/call-status-box.component.ts